export default "__VITE_PUBLIC_ASSET__610499c5__"